import { render } from "./CustomerMealReservation.vue?vue&type=template&id=43bc1769&scoped=true"
import script from "./CustomerMealReservation.vue?vue&type=script&lang=js"
export * from "./CustomerMealReservation.vue?vue&type=script&lang=js"

import "./CustomerMealReservation.vue?vue&type=style&index=0&id=43bc1769&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bc1769"]])

export default __exports__